






















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { useIdentifyRecipient } from '@getaccept/lib-shared/src/lobby/composables/identify-recipient.composable';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import Consents from './Consents.vue';
import IdentifyWrapper from './IdentifyWrapper.vue';
import RequestAccess from './RequestAccess.vue';
import UniversalForm from './UniversalForm.vue';
import PrivateForm from './PrivateForm.vue';

export default defineComponent({
  components: {
    Consents,
    IdentifyWrapper,
    RequestAccess,
    UniversalForm,
    PrivateForm,
  },
  props: {
    authStep: {
      type: Object as PropType<AuthenticationStep>,
      required: true,
    },
    submittingResponse: {
      type: Boolean,
    },
    consentSteps: {
      default: () => [],
      type: Array as PropType<AuthenticationStep[]>,
    },
    logoUrl: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { email, handleClick, universalLinkUrl, notMatchingEmail } = useIdentifyRecipient(
      props,
      emit
    );

    const privateFormIsVisible = ref(true);
    const showConsents = ref(true);
    const isPrivateRoomError = computed(() => !universalLinkUrl.value && notMatchingEmail.value);
    const isPublicRoomError = computed(() => universalLinkUrl.value && notMatchingEmail.value);
    const isIdentifyStep = computed(
      () => props.authStep.type === AuthenticationStepType.IdentifyRecipient
    );

    const rightPaneMessage = computed(() =>
      isPrivateRoomError.value && !privateFormIsVisible.value
        ? t('dr_room_is_private')
        : t('dr_welcome_to_our_room')
    );

    const hasUnansweredConsents = computed(
      () => showConsents.value && props.consentSteps.length > 0
    );

    const handleSubmit = (updatedEmail: string) => {
      if (props.authStep.data?.error && email.value === updatedEmail) {
        privateFormIsVisible.value = false;
        return;
      }

      email.value = updatedEmail;
      handleClick();
    };

    const storedConsents = ref<{ type: AuthenticationStepType; value: string }[]>([]);

    const handleAnswer = (
      consents: {
        type: AuthenticationStepType;
        value: string;
      }[]
    ) => {
      showConsents.value = false;
      storedConsents.value = consents;
      emit('consent-answer', consents);
    };

    watch(
      () => props.authStep,
      () => {
        if (props.authStep.data?.error) {
          privateFormIsVisible.value = false;
        }
      }
    );

    return {
      email,
      handleClick,
      handleAnswer,
      showConsents,
      hasUnansweredConsents,
      rightPaneMessage,
      isPublicRoomError,
      isPrivateRoomError,
      privateFormIsVisible,
      handleSubmit,
      storedConsents,
      isIdentifyStep,
    };
  },
});
